import { ENVIRONMENTS, getEnvFromHostname } from 'pages/utils/getEnvFromHostname';

class Churnzero {
  init() {
    // Do not load ChurnZero if it's already loaded,
    // or if we are in Stencil's Retail Manager.
    if (window.ChurnZero || window.isGriffin()) {
      return;
    }

    // We will be using the environment to conditionally run churnzero on prod
    const isProductionEnvironment = getEnvFromHostname() === ENVIRONMENTS.PRODUCTION;

    window.merchantos.session.init().done(async () => {
      const { status: AccountStatus } = window.merchantos.account || {};
      const session = window.merchantos.session.sessData || {};

      const script = await window.lsCloud.Config.access('churnzero_script');
      const appKey = await window.lsCloud.Config.access('churnzero_app_key');
      const lightspeedUID = (await window.lsCloud.Options.get('lightspeed_uid')) || false;

      const isImpersonator = Object.prototype.hasOwnProperty.call(session, 'Impersonator');

      const { systemCustomerID: accountID } = session;
      const { email } = session.Employee;
      const externalID = isProductionEnvironment ? lightspeedUID : accountID;

      /* We do not want to load ChurnZero in production for:
         - non-customers,
         - suspended accounts,
         - impersonators,
         - if lightspeedUID is not set,
         - or if email is not set. */
      if (
        isProductionEnvironment &&
        (AccountStatus !== 'customer' ||
          AccountStatus === 'suspended' ||
          isImpersonator ||
          !lightspeedUID ||
          !email)
      ) {
        return;
      }

      // Create element for ChurnZero to inject ChurnZero
      const rootEl = window.document.createElement('script');
      rootEl.setAttribute('id', `CZ_${getEnvFromHostname()}`);

      /* eslint-disable */
      // prettier-ignore
      rootEl.textContent = `var ChurnZero = window.ChurnZero || [];
      (function(a,b,c,d){var cz=a.createElement(b); cz.type=c; cz.async=true; cz.src=d;var s=a.getElementsByTagName(b)[0];s.parentNode.insertBefore(cz, s);})(document, "script",'text/javascript', '${script}');
      ChurnZero.push(['setAppKey', '${appKey}']);
      ChurnZero.push(['setContact', '${externalID}', '${email}']);
      ChurnZero.push(['setModule', 'R-Series']);`;
      /* eslint-enable */

      window.document.body.appendChild(rootEl);
    });
  }
}

export default new Churnzero();
